export enum DialogLevel {
	DANGER,
	INFO,
	SUCCESS,
	WARNING,
}
